import { MultiItemStore } from 'stores/multi-item-store';

import { PackageType } from 'src/common/models/multi-item/multi-item-types';

import { UitkLayoutGridItemProps, UitkLayoutGridProps } from 'uitk-react-layout-grid';

export const getGridProps = (multiItem?: MultiItemStore) => {
  if (isFlightPath(getPackageType(multiItem))) {
    return {
      columns: {
        small: 1,
        medium: 2,
        large: 3,
      },
      space: 'two',
    } as UitkLayoutGridProps;
  } else if (isCarPath(getPackageType(multiItem))) {
    return {
      columns: {
        small: 1,
        medium: 4,
        large: 6,
      },
      space: 'two',
    } as UitkLayoutGridProps;
  }
};

export const getGridItemProps = (fieldKey: string, multiItem?: MultiItemStore) => {
  if (isFlightPath(getPackageType(multiItem))) {
    switch (fieldKey) {
      case 'dateRange':
        return {
          colSpan: {
            small: 1,
            medium: 2,
          },
        } as UitkLayoutGridItemProps;
      default:
        return {
          colSpan: 1,
        } as UitkLayoutGridItemProps;
    }
  } else if (isCarPath(getPackageType(multiItem))) {
    switch (fieldKey) {
      case 'dateRange':
        return {
          colSpan: {
            small: 1,
            medium: 2,
          },
        } as UitkLayoutGridItemProps;
      case 'location':
        return {
          colSpan: {
            small: 'all',
            medium: 4,
            large: 2,
          },
        } as UitkLayoutGridItemProps;
      // case 'carPickupDropoffTimeRange':
      //   return {
      //     colSpan: {
      //     },
      //   } as UitkLayoutGridItemProps;
      default:
        return {};
    }
  }
};

const isFlightPath = (packageType?: PackageType) => packageType && [PackageType.FH, PackageType.FHC].includes(packageType);

const isCarPath = (packageType?: PackageType) => packageType && packageType === PackageType.HC;

const getPackageType = (multiItem?: MultiItemStore) => multiItem?.multiItemContext?.packageType;
